import React, { useEffect, useState, useMemo } from "react";
import { urlConversion, endpointGetConversions } from '../services/Endpoints';
import { Loading } from "./Loading";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import Paginator from "./Paginator";
import ObservationsModal from "./ObservationsModal";
import PortadasModal from "./PortadasModal";
import { ActionsMenu } from "./AccountsUsers/ActionsMenu";

export function PortadasList({ filters, refreshKey }) {

    const [loading, setLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState('');
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [selectedProjectUpload, setSelectedProjectUpload] = useState(null);
    const itemsPerPage = 10;

    const [isObsModalOpen, setIsObsModalOpen] = useState(false);
    const [selectedProjectObs, setSelectedProjectObs] = useState(null);

    useEffect(() => {
        getConversions();
    }, [refreshKey]);

    const getConversions = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${urlConversion}${endpointGetConversions}`);
            const res = await response.json();
            if (res && res.status == 'success') {
                setProjects(res.data.projects);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const getCoverStatus = (project) => {
        return String(project.cover_info?.status || project.cover_status || project.status);
    };

    const filteredProjects = useMemo(() => {
        let result = projects.filter(project => {
            const hasService = project.services?.includes('cover');
            if (!hasService) return false;

            const serviceStatus = getCoverStatus(project);
            const matchStatus = statusFilter === '' || serviceStatus === statusFilter;
            const matchAccount = filters.account === '' || project.account.toLowerCase().includes(filters.account.toLowerCase());
            const matchInkId = filters.ink_id === '' || String(project.ink_id).toLowerCase().includes(filters.ink_id.toLowerCase());
            return matchStatus && matchAccount && matchInkId;
        });

        const orderMap = { '0': 1, '2': 2, '1': 3 };
        result.sort((a, b) => (orderMap[getCoverStatus(a)] || 99) - (orderMap[getCoverStatus(b)] || 99));

        return result;
    }, [projects, filters, statusFilter]);

    const paginatedProjects = useMemo(() => {
        const offset = (currentPage - 1) * itemsPerPage;
        return filteredProjects.slice(offset, offset + itemsPerPage);
    }, [filteredProjects, currentPage]);

    const handleViewUserFile = (project) => {
        const fileUrl = project.cover_info?.user_file;
        if (fileUrl) {
            window.open(fileUrl, '_blank');
        } else {
            alert('No hay archivo disponible');
        }
    };

    const handleOpenUpload = (project) => {
        setSelectedProjectUpload(project);
        setIsUploadModalOpen(true);
    };

    const handleUploadSuccess = () => {
        setIsUploadModalOpen(false);
        setSelectedProjectUpload(null);
        getConversions();
    };

    const handleOpenObs = (project, mode = 'general') => {
        setSelectedProjectObs({
            ...project,
            initialMode: mode,
            observations: project.cover_info?.observations || project.observations
        });
        setIsObsModalOpen(true);
    };

    return (
        <>
            {loading && <Loading />}

            <div className="row mb-3 mt-4">
                <div className="col-md-4 col-lg-3">
                    <label className="fw-bold mb-2 small text-uppercase text-white opacity-75">Estado de Portada</label>
                    <div className="d-flex gap-2">
                        <select
                            className="form-select bg-dark text-white border-secondary py-2"
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                        >
                            <option value="">Todos los estados</option>
                            <option value="0">Pendiente información</option>
                            <option value="1">Solicitud</option>
                            <option value="2">Pendiente de aprobación</option>
                            <option value="3">Solicitud de cambio</option>
                            <option value="4">Aprobado</option>
                        </select>
<button
                            className="btn btn-ink-icon"
                            onClick={() => getConversions()}
                            title="Recargar lista"
                        >
                            <FontAwesomeIcon icon={faSync} spin={loading} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="modern-table-container">
                <table className="modern-table striped-table">
                    <thead>
                        <tr>
                            <th>Estado</th><th>Cuenta</th><th>Ink id</th><th>Título</th><th>Revisiones</th><th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedProjects.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center py-5 text-white-50">
                                    <h6 className="m-0 opacity-50">No se encontraron resultados para los filtros aplicados</h6>
                                </td>
                            </tr>
                        ) : (
                            paginatedProjects.map((project) => {
                                const serviceStatusId = getCoverStatus(project);
                                const iterations = project.cover_info?.revisions_used || 0;
                                let statusLabel = 'Pendiente información';
                                if (String(serviceStatusId) === '1') statusLabel = 'Solicitud';
                                else if (String(serviceStatusId) === '0') statusLabel = 'Pendiente información';
                                else if (String(serviceStatusId) === '2') statusLabel = 'Pendiente de aprobación';
                                else if (String(serviceStatusId) === '3') statusLabel = 'Solicitud de cambio';
                                else if (String(serviceStatusId) === '4') statusLabel = 'Aprobado';

                                const items = [];
                                if (project.cover_info?.user_file) {
                                    items.push({ label: 'Descargar archivo', onClick: () => handleViewUserFile(project) });
                                }
                                items.push({ label: 'Observaciones', onClick: () => handleOpenObs(project) });
                                items.push({ label: 'Subir portada', onClick: () => handleOpenUpload(project) });

                                return (
                                    <tr key={`${project.account}-${project.ink_id}`}>
                                        <td className="short">
                                            <span className={`badge-status status-${serviceStatusId}`}>
                                                {statusLabel}
                                            </span>
                                        </td>
                                        <td className="short">{project.account}</td>
                                        <td className="short">{project.ink_id}</td>
                                        <td>{project.title}</td>
                                        <td className="short text-center">
                                            <span
                                                className={`badge ${iterations > 0 ? 'bg-primary' : 'bg-secondary opacity-50'}`}
                                                onClick={iterations > 0 ? () => handleOpenObs(project, 'revisions') : undefined}
                                                title={iterations > 0 ? "Ver historial de revisiones" : ""}
                                                style={{ cursor: iterations > 0 ? 'pointer' : 'default' }}
                                            >
                                                {iterations > 0 ? iterations : '-'}
                                            </span>
                                        </td>
                                        <td>
                                            <ActionsMenu items={items} title="Acciones de la portada" />
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>
            {filteredProjects.length > itemsPerPage && (
                <Paginator
                    totalItems={filteredProjects.length}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                />
            )}

            <PortadasModal
                isOpen={isUploadModalOpen}
                onClose={() => setIsUploadModalOpen(false)}
                project={selectedProjectUpload}
                onSuccess={handleUploadSuccess}
            />

            <ObservationsModal
                isOpen={isObsModalOpen}
                onClose={() => setIsObsModalOpen(false)}
                project={selectedProjectObs}
            />
        </>
    );
}

export default PortadasList;
